import { Theme } from '@mui/material';

export const sxStyles = {
  saveButtonWrap: {
    maxWidth: '142px',
  },

  radioEndAdornment: (theme: Theme) => ({
    position: 'absolute',
    right: '-0.938rem',
    bottom: '0.5rem',

    '& > svg:first-of-type': {
      fill: theme.palette.grey['600'],
    },
  }),
};
